"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.invoiceSeriesRequest = invoiceSeriesRequest;
const MainSetupReact_1 = __importDefault(require("../../React/MainSetupReact"));
async function invoiceSeriesRequest(route, input, signal) {
    const response = await fetch(MainSetupReact_1.default.serverUrl + route, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(input),
        signal,
    });
    const data = await response.json();
    if (!response.ok) {
        const error = new Error(data.errorMessage || data.error?.message || data.error || data.message || "Nie udało się zapisać serii.");
        throw Object.assign(error, { status: response.status });
    }
    return data;
}
